import React, { useState, useEffect } from 'react';
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import SecBTN from '../../UI/SecBTN';
import Input from '../../UI/Input/Input';
import Graybg from '../../UI/Graybg';
import Select from '../../UI/Select/Select';
import userService from '../../app/services/user.service';

const UploadExercise = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [examType, setExamType] = useState('');
  const [target, setTarget] = useState('');
  const [session, setSession] = useState('');
  const [type, setType] = useState('New');
  const [file, setFile] = useState(null);
  
  // New state for the API data
  const [examTypeList, setExamTypeList] = useState([]);
  const [targetList, setTargetList] = useState([]);
  const [sessionList, setSessionList] = useState([]);

  // Fetch all dropdown data when component mounts
  useEffect(() => {
    fetchExamTypeList();
    fetchTargetList();
    fetchSessionList();
  }, []);

  // Set default values after data is loaded
  useEffect(() => {
    if (examTypeList.length > 0 && !examType) {
      setExamType(examTypeList[0].exam_type_id);
    }
    if (targetList.length > 0 && !target) {
      setTarget(targetList[0].target_id);
    }
    if (sessionList.length > 0 && !session) {
      setSession(sessionList[0].session_id);
    }
  }, [examTypeList, targetList, sessionList]);

  // Function to fetch exam type list
  const fetchExamTypeList = () => {
    userService.ExamTypeList()
      .then(res => {
        console.log(res)
        setExamTypeList(res.examtype_data);
      })
      .catch(err => {
        console.error("Error fetching exam types:", err);
      });
  };

  // Function to fetch target list
  const fetchTargetList = () => {
    userService.TargetList()
      .then(res => {
        setTargetList(res.target_data);
      })
      .catch(err => {
        console.error("Error fetching targets:", err);
      });
  };

  // Function to fetch session list
  const fetchSessionList = () => {
    userService.SessionList()
      .then(res => {
        setSessionList(res.session_data);
      })
      .catch(err => {
        console.error("Error fetching sessions:", err);
      });
  };

  const handleExamTypeChange = (e) => {
    setExamType(e.target.value);
  };

  const handleTargetChange = (e) => {
    setTarget(e.target.value);
  };

  const handleSessionChange = (e) => {
    setSession(e.target.value);
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = () => {
    const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
    if (!file) {
      alert('Please select a file to upload');
      return;
    }

    setLoading(true);
    
    const formData = new FormData();
    formData.append('exercise_dpp_file', file);
    formData.append('exam_type', examType);
    formData.append('target', target);
    formData.append('session', session);
    formData.append('typemode', type);
    formData.append("user_id", user_id);

    userService.uploadExercise(formData)
      .then(res => {
        console.log(res.data);
        alert('File uploaded successfully');
        setLoading(false);
        setFile(null);
        // Reset file input
        document.getElementById('formFile').value = '';
      })
      .catch(err => {
        console.log(err);
        alert('Error uploading file');
        setLoading(false);
      });
  };

  const downloadFile = () => {
    fetch(window.location.origin+"/files/sample-format-dpp_new.xlsx").then((response) => {
      response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "sample-format-dpp.xlsx";
          
          alink.click();
      });
    });
  };

  const downloadFile1 = () => {
    fetch(window.location.origin+"/files/sample-format-exercise_new.xlsx").then((response) => {
      response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "sample-format-exercise.xlsx";
          alink.click();
      });
    });
  };

  return (
    <div>
      {loading && <div className="text-center">Loading...</div>}
      <Row>
        <Col lg={6} md={6} sm={12} className="mb-3">
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Select Exam Type:</Form.Label>
            <Select value={examType} onChange={handleExamTypeChange}>
              {examTypeList.map((item, index) => (
                <option key={index} value={item.exam_type_id}>{item.exam_type}</option>
              ))}
            </Select>
          </Form.Group>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Select Target:</Form.Label>
            <Select value={target} onChange={handleTargetChange}>
              {targetList.map((item, index) => (
                <option key={index} value={item.target_id}>{item.target}</option>
              ))}
            </Select>
          </Form.Group>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Select Session:</Form.Label>
            <Select value={session} onChange={handleSessionChange}>
              {sessionList.map((item, index) => (
                <option key={index} value={item.session_id}>{item.session}</option>
              ))}
            </Select>
          </Form.Group>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Select Type:</Form.Label>
            <Select value={type} onChange={handleTypeChange}>
              <option value="New">New</option>
              <option value="Old">Old</option>
              <option value="Online">Online</option>
            </Select>
          </Form.Group>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Upload here:</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
          </Form.Group>
          <SecBTN className="sec-btn1" onClick={handleUpload} disabled={loading}>
            {loading ? 'Uploading...' : 'Upload'}
          </SecBTN>
        </Col>
        <Col lg={6} md={8} sm={12}>
          <SecBTN className="sec-btn1" style={{marginRight:"10px"}} onClick={downloadFile1}>
            <i className="fa fa-download"></i> Sample Exercise File
          </SecBTN>
          <SecBTN className="sec-btn1" onClick={downloadFile}>
            <i className="fa fa-download"></i> Sample DPP File
          </SecBTN>
          {data.length > 0 && (
            <div className="mt-4">
              <h5>Fetched Exercise Data:</h5>
              <pre>{JSON.stringify(data, null, 2)}</pre>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UploadExercise;